module.exports = __webpack_public_path__ + "static/eye-7293006b29a337cffb54d114f274f6c6.jpg";